import { useToast } from "@chakra-ui/react";
import type { AxiosError } from "axios";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import type { ModelState, SetPasswordInfo, SetPasswordRequest } from "../dtos";
import { BadRequestError } from "../dtos";
import apiClient from "../Utils/apiClient";
import { setModelStateErrors } from "../Utils/formModelState";

const baseUrl = import.meta.env.VITE_BASE_URL
const apiUrl = import.meta.env.VITE_ACCOUNT_API
const url = `${baseUrl}/${apiUrl}`

export const useGetSetPasswordInfo = () => {
    return useQuery({
        queryKey: ['getSetPasswordInfo'],
        queryFn: () =>
            apiClient.get<SetPasswordInfo>(`${url}/GetSetPasswordInfo`),
    })
}

export const useSetPasswordMutation = () => {
    return useMutation({
        mutationFn: (payload: SetPasswordRequest) =>
            apiClient.post(`${url}/SetPassword`, payload),
    })
}

export const useSetPasswordForm = (userId: string, onPasswordReset: () => void) => {
    const { mutateAsync: setPasswordAsync, isSuccess, isError } = useSetPasswordMutation()


    const form = useForm<SetPasswordRequest>({
        defaultValues: {
            userId,
            password: '',
        },
    })

    const { handleSubmit, setError } = form

    const toast = useToast()

    const submitHandler = handleSubmit(
        (data) => setPasswordAsync(data)
            .then(() => {
                toast({
                    title: 'Heslo bylo změněno',
                    status: 'success',
                })
                onPasswordReset()
            })
            .catch((e: AxiosError) => {
                console.error(e)
                if (e.response?.status === 400)
                    setModelStateErrors(setError, new BadRequestError(e.response.data as ModelState<SetPasswordRequest>))
                else
                    toast({
                        title: 'Při změně hesla došlo k chybě.',
                        status: 'error',
                    })
            })
    )

    return {
        isSuccess,
        isError,
        form,
        submitHandler
    }
}